/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S3_L1Inputs */

const en_landing_guide_s3_l1 = /** @type {(inputs: Landing_Guide_S3_L1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posters and event graphics: set the headline in quotes, then update dates, venues or prices without regenerating the layout.`)
};

const zh_landing_guide_s3_l1 = /** @type {(inputs: Landing_Guide_S3_L1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`海报与活动物料：用引号写好标题，之后更新日期、场地或价格，无需重做版式。`)
};

/**
* | output |
* | --- |
* | "Posters and event graphics: set the headline in quotes, then update dates, venues or prices without regenerating the layout." |
*
* @param {Landing_Guide_S3_L1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s3_l1 = /** @type {((inputs?: Landing_Guide_S3_L1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S3_L1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s3_l1(inputs)
	return zh_landing_guide_s3_l1(inputs)
});
export { landing_guide_s3_l1 as "landing.guide.s3_l1" }